import { useKeycloak } from '@/contexts/KeycloakContext';
import { ActionCard } from '@/components/ActionCard';
import { EnergySlider } from '@/components/EnergySlider';

export function Home() {
  const { user } = useKeycloak();

  return (
    <div className="p-4 space-y-6">
      {/* Header */}
      <header className="pt-2">
        <p className="text-white/50 text-sm">
          {new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
          })}
        </p>
        <h1 className="text-2xl font-bold">
          Hey, {user?.givenName || user?.name?.split(' ')[0] || 'there'}
        </h1>
      </header>

      {/* Energy Check-in */}
      <section className="card">
        <EnergySlider />
      </section>

      {/* Priority Action */}
      <section>
        <h2 className="text-sm font-medium text-white/50 mb-3 uppercase tracking-wide">
          What to do right now
        </h2>
        <ActionCard />
      </section>
    </div>
  );
}
